import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./ProductSlide.css";

const ProductSlide = ({ title, products = [] }) => {
  // Transform API products to match the component's expected structure
  const transformedProducts = products.map((product) => ({
    productId: product.productId,
    name: product.name,
    price: parseFloat(product.price || 0),
    discount: parseFloat(product.discount || 0),
    images: product.productImages?.map((img) => img.imageSource) || ["images/products/placeholder.jpg"],
  }));

  useEffect(() => {
    if (window.initProductSlide && transformedProducts.length > 0) {
      window.initProductSlide();
    }
  }, [transformedProducts]);

  return (
    transformedProducts.length>0 && (
      <section className="flat-spacing-4 pt_0">
        <div className="container">
          <div className="flat-title">
            <span className="title">{title}</span>
          </div>
          <div className="hover-sw-nav hover-sw-2">
            <div className="swiper tf-sw-recent wrap-sw-over" data-preview="4" data-tablet="3" data-mobile="2" data-space-lg="30" data-space-md="30" data-space="15" data-pagination="1" data-pagination-md="1" data-pagination-lg="1">
              <div className="swiper-wrapper">
                {transformedProducts.map((product) => (
                  <div key={product.productId} className="swiper-slide" lazy="true">
                    <div className="card-product">
                      <div className="card-product-wrapper">
                        <Link to={`/productDetail?productId=${product.productId}`} className="product-img" aria-label={`View ${product.name} on shop page`}>
                          <img className="lazyload img-product" data-src={product.images[0]} src={product.images[0]} alt={product.name} loading="lazy" />
                          {product.images.length > 1 && <img className="lazyload img-hover" data-src={product.images[1]} src={product.images[1]} alt={product.name} loading="lazy" />}
                        </Link>
                      </div>
                      <div className="card-product-info">
                        <Link to={`/shop?productId=${product.productId}`} className="title link" aria-label={`View ${product.name} on shop page`}>
                          {product.name}
                        </Link>
                        {product.discount > 0 ? (
                          <div>
                            <span className="price discount-price">₹{(product.price - product.price * (product.discount / 100)).toFixed(2)}</span>
                            <br />
                            <span
                              className="price original-price"
                              style={{
                                textDecoration: "line-through",
                                color: "red",
                              }}>
                              MRP: ₹{product.price.toFixed(2)}
                            </span>{" "}
                            <span className="discount-percent">({product.discount}% off)</span>
                          </div>
                        ) : (
                          <span className="price">MRP: ₹{product.price.toFixed(2)}</span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="nav-sw nav-next-slider nav-next-recent box-icon w_46 round">
              <span className="icon icon-arrow-left"></span>
            </div>
            <div className="nav-sw nav-prev-slider nav-prev-recent box-icon w_46 round">
              <span className="icon icon-arrow-right"></span>
            </div>
            <div className="sw-dots style-2 sw-pagination-recent justify-content-center"></div>
          </div>
        </div>
      </section>
    )
  );
};

export default ProductSlide;
